import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            探索六角琴世界
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大内容板块，覆盖六角琴学习的每一个阶段与需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-md bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-600 group-hover:text-background-50 transition-colors w-5 h-5 md:w-6 md:h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-500 group-hover:text-primary-600 whitespace-nowrap">
                浏览文章
                <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}